import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Modal, Row, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { IoCopyOutline } from "react-icons/io5";
import { formatDateTime } from "../../utils/dateFormatUtils";
import { ImageNo } from "../image/ImageComponent";
import { getDataRequest, postDataRequest } from "../../api/serviceMethods";
import { ORDER_SHIPED_URL, ORDERS_URL } from "../../api/URLs";
import InputComponent from "../input/InputComponent";
import MessageConfirmModal from "../messageModal/MessageConfirmModal";
import OrderShippedSvg from "../../assets/images/OrderShippedSvg";

const ShippingModal = (props) => {
    const { setModalOpen, modalOpen, initLoadOrder, handleCopy, shippedId, isShipped, showAddress } = props;
    const [shipmentStore, setShipmentStore] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [dataObject, setDataObject] = useState({
        trackingNo: ""
    });
    const messageModalRef = useRef("");
    const { t } = useTranslation();

    const getshipmentDetail = async () => {
        if (!shippedId) return;
        try {
            setLoading(true);
            const res = await getDataRequest(`${ORDERS_URL}/${shippedId}`);
            if (res.status === 200) {
                setShipmentStore(res.data);
            }
        } catch (error) {
            console.error("Error fetching order data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (modalOpen && shippedId) {
            getshipmentDetail();
        }
    }, [shippedId, modalOpen]);

    const checkError = () => {
        if (!dataObject.trackingNo || !dataObject.trackingNo.trim()) {
            return true;
        }
        return false;
    };

    const handleSubmit = async () => {
        setIsSubmit(true);

        if (checkError()) {
            return false;
        }
        setLoading(true);

        const shippedPayload = {
            trackingNo: dataObject && dataObject.trackingNo ? dataObject.trackingNo.trim() : "",
            orderId: shipmentStore?.items?.[0]?.orderId || shipmentStore?._id || shipmentStore?.id
        };

        try {
            const res = await postDataRequest(ORDER_SHIPED_URL, shippedPayload);
            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(t(res?.message) || t('Saved Successfully'), () => {
                    initLoadOrder();
                    setDataObject({ trackingNo: "" });
                    setModalOpen(false);
                }, "", true);
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res.data?.message || res.message || t("An error occurred"));
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err?.message || "");
        } finally {
            setLoading(false);
            setIsSubmit(false);
        }
    };

    const formatShippingAddress = (shippingInfo) => {
        if (!shippingInfo) return "";

        const {
            addressLine1,
            addressLine2,
            district,
            city,
            province,
            zipCode,
            country,
        } = shippingInfo;

        return [
            addressLine1,
            addressLine2,
            district,
            city,
            province,
            zipCode,
            country,
        ]
            .filter(Boolean)
            .join(", ");
    };

    const getProductImage = (item) => {
        if (!item) return ImageNo;
        if (Array.isArray(item.images) && item.images.length > 0) {
            const firstImg = item.images[0];
            if (typeof firstImg === 'string') return firstImg;
            if (typeof firstImg === 'object' && firstImg?.url) return firstImg.url;
        }
        return item.picUrl || item.imageUrl || item.image || ImageNo;
    };

    return (
        <>
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <OrderShippedSvg />
                        <span style={{ marginLeft: "10px" }}>{isShipped ? t('Order Details') : t('Order Shipped')}</span>
                    </div>
                }
                centered
                width={850}
                open={modalOpen}
                className='custom-modal'
                onOk={() => setModalOpen(false)}
                onCancel={() => {
                    setModalOpen(false);
                    setDataObject({ trackingNo: "" });
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <Spin spinning={loading}>
                    <hr />
                    <div style={{ marginBottom: "20px", marginTop: '10px' }}>
                        <div>
                            <Row style={{
                                backgroundColor: "#f9fafb",
                                padding: "12px 15px",
                                borderRadius: "6px",
                                fontWeight: 500,
                                alignItems: "center"
                            }}>
                                <Col md={3} className="titleCardNew14400">{t("Product Photo")}</Col>
                                <Col md={10} className="titleCardNew14400">{t("Product Name")}</Col>
                                <Col md={2} className="titleCardNew14400 text-center">{t("Quantity")}</Col>
                                <Col md={6} className="titleCardNew14400" style={{ paddingLeft: "12px" }}>{t("Order Num")}</Col>
                                <Col md={3} className="titleCardNew14400" style={{ paddingLeft: "12px" }}>{t("Payment Amount")}</Col>
                            </Row>
                            {
                                shipmentStore?.items?.map((item, index) => (
                                    <Row key={item?._id || item?.id || index} style={{ padding: "12px 15px", alignItems: "center", borderBottom: "1px solid #f0f0f0" }}>
                                        <Col md={3} className="titleCardNew14400">
                                            <img
                                                style={{
                                                    width: "70px",
                                                    height: "75px",
                                                    borderRadius: "6px",
                                                    objectFit: "cover",
                                                    border: "1px solid #f0f0f0"
                                                }}
                                                src={getProductImage(item)}
                                                alt={item?.productName || "Product"}
                                            />
                                        </Col>

                                        <Col md={10} className="titleCardNew14400" style={{ paddingRight: "10px" }}>
                                            <div style={{ fontWeight: 500, color: "#333", fontSize: "13px" }}>{item?.productName}</div>
                                            {/* {item?.productNo && (
                                                <div style={{ color: "#8c8c8c", fontSize: "11px", marginTop: "2px" }}>{item.productNo}</div>
                                            )} */}
                                        </Col>

                                        <Col md={2} className="titleCardNew14400 text-center" style={{ fontSize: "14px", fontWeight: 500 }}>
                                            {item?.qty || item?.quantity || 1}
                                        </Col>

                                        <Col md={6} className="titleCardNew14400" style={{ paddingLeft: "12px", wordBreak: "break-all", color: "#545454", fontSize: "13px" }}>
                                            {shipmentStore?.orderId || item?.orderId}
                                        </Col>

                                        <Col md={3} className="titleCardNew14400" style={{ paddingLeft: "12px", fontWeight: 500, color: "#E50A47", fontSize: "14px" }}>
                                            ￥{item?.subTotal !== undefined ? item?.subTotal?.toFixed(2) : (item?.unitPrice !== undefined ? item.unitPrice?.toFixed(2) : shipmentStore?.total?.toFixed(2))}
                                        </Col>
                                    </Row>
                                ))
                            }

                        </div>
                    </div>
                    <div className="mb-3">
                        <Card>
                            <Row gutter={[16, 16]}>
                                <Col md={13}>
                                    <div style={{ fontWeight: 600, fontSize: "14px", color: "#333", display: "flex", alignItems: "center" }}>
                                        {t("Receiving Introduction")}
                                        <IoCopyOutline
                                            color="#8c8c8c"
                                            style={{ cursor: "pointer", marginLeft: 8 }}
                                            title={t("Copy Address")}
                                            onClick={() => handleCopy && showAddress && handleCopy(showAddress(shipmentStore && shipmentStore?.shippingInfo))}
                                        />
                                    </div>
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                        <Row>
                                            <Col md={7} className="titleCardNew14400" style={{ color: "#8c8c8c" }}>{t("Consignee")}: </Col>
                                            <Col md={17} className="titleCardNew14400" style={{ fontWeight: 500 }}>
                                                {shipmentStore?.shippingInfo?.recipientName || ""}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={7} className="titleCardNew14400" style={{ color: "#8c8c8c" }}>{t("Phone Number")}: </Col>
                                            <Col md={17} className="titleCardNew14400" style={{ fontWeight: 500 }}>
                                                {shipmentStore?.shippingInfo?.phone?.number
                                                    ? `${shipmentStore.shippingInfo.phone.number}`
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row style={{ alignItems: "start" }}>
                                            <Col md={7} className="titleCardNew14400" style={{ color: "#8c8c8c" }}>{t("Delivery Address")}: </Col>
                                            <Col md={17} className="titleCardNew14400" style={{ whiteSpace: "break-spaces", fontWeight: 500 }}>
                                                {formatShippingAddress(shipmentStore && shipmentStore?.shippingInfo)}
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col md={11}>
                                    <div style={{ fontWeight: 600, fontSize: "14px", color: "#333" }}>
                                        {t("Purchase Introduction")}
                                    </div>
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                        <Row>
                                            <Col md={9} className="titleCardNew14400" style={{ color: "#8c8c8c" }}>{t("User Id")}: </Col>
                                            <Col md={15} className="titleCardNew14400" style={{ fontWeight: 500 }}>{shipmentStore && shipmentStore?.memberNo}</Col>
                                        </Row>
                                        <Row>
                                            <Col md={9} className="titleCardNew14400" style={{ color: "#8c8c8c" }}>{t("Payment Time")}: </Col>
                                            <Col md={15} className="titleCardNew14400" style={{ fontWeight: 500 }}>
                                                {shipmentStore && shipmentStore.paymentTS ? formatDateTime(shipmentStore.paymentTS) : "-"}
                                            </Col>
                                        </Row>
                                        {(shipmentStore?.shippingInfo?.trackingNo || isShipped) && (
                                            <>
                                                <Row align="middle">
                                                    <Col md={9} className="titleCardNew14400" style={{ color: "#8c8c8c" }}>{t("Tracking Number")}: </Col>
                                                    <Col md={15} className="titleCardNew14400" style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                                                        {shipmentStore?.shippingInfo?.trackingNo || "-"}
                                                        {shipmentStore?.shippingInfo?.trackingNo && (
                                                            <IoCopyOutline
                                                                color="#8c8c8c"
                                                                style={{ cursor: "pointer", marginLeft: 6 }}
                                                                title={t("Copy Tracking Number")}
                                                                onClick={() => handleCopy && handleCopy(shipmentStore.shippingInfo.trackingNo)}
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>
                                                {shipmentStore?.shippingInfo?.shippedAt && (
                                                    <Row>
                                                        <Col md={9} className="titleCardNew14400" style={{ color: "#8c8c8c" }}>{t("Shipping Time")}: </Col>
                                                        <Col md={15} className="titleCardNew14400" style={{ fontWeight: 500 }}>
                                                            {formatDateTime(shipmentStore.shippingInfo.shippedAt)}
                                                        </Col>
                                                    </Row>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </div>
                    {
                        isShipped ? "" :
                            <>
                                <div style={{ borderBottom: "1px dashed #ddd", marginBottom: "16px" }}></div>
                                <div className='d-flex align-items-baseline' style={{ padding: "10px 60px", }}>
                                    <Col md={4} >{t("Upload Order Number")} :</Col>
                                    <Col md={20}>
                                        <InputComponent
                                            status={isSubmit && !dataObject.trackingNo && `error`}
                                            value={dataObject?.trackingNo || ""}
                                            setValue={(value) => setDataObject({ ...dataObject, trackingNo: value })}
                                        />
                                    </Col>
                                </div>
                                <div className='d-flex justify-content-center mt-3'>
                                    <Button
                                        style={{
                                            backgroundColor: "#E50A47",
                                            border: "none",
                                            color: "White",
                                            height: "45px",
                                            width: "230px",
                                            margin: "auto",
                                            borderRadius: "10px",
                                            fontSize: "16px",
                                            fontWeight: 500
                                        }}
                                        onClick={handleSubmit}
                                    >
                                        {t("Confirm Submit")}
                                    </Button>
                                </div>
                            </>
                    }

                </Spin>
            </Modal>
            <MessageConfirmModal textCentered ref={messageModalRef} />
        </>
    );
};

export default ShippingModal;